<template>
  <span>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
    <v-card class="card--flex-toolbar">
      <v-toolbar color="blue-grey lighten-5" class="elevation-0" tabs>
        <v-toolbar-title>
          <h5>Cadastro de Departamentos</h5>
        </v-toolbar-title>
        <v-tabs
          v-model="active"
          show-arrows
          slot="extension"
          color="grey lighten-4"
          slider-color="black"
        >
          <v-tab key="1" ripple>Departamento</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="active" style="min-height:300px">
          <v-tab-item key="1">
            <v-form v-model="valid">
              <v-container fluid>
                <v-layout row wrap>
                  <!-- LINHA 1, CAMPO CODIGO -->
                  <v-flex xs12 sm2>
                    <v-text-field
                      v-model="departamento.id"
                      label="Código"
                      v-bind:disabled='true'
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm8>
                    <v-text-field v-model="departamento.descricao" label="Descrição" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field v-model="departamento.centro_custo" label="Centro de Custo"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn small color="primary" @click="$router.push('/departamentos')">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="salvar()" :loading="loading">Salvar</v-btn>
      </v-card-actions>
    </v-card>
    <div style="margin:50px"></div>
  </span>
</template>
<script>
import { showFlash, showError } from '@/utils'
import departamentosService from '@/services/departamentos'

export default {
  name: 'departamento',
  data () {
    return {
      item: {
        lanctto: ''
      },
      itemlancto: {
        descr: ''
      },
      tipo: {
        descr: ''
      },
      resultado: {},
      departamento: {},
      searchInput: '',
      loading: false,
      valid: true,
      active: 0,
      modo: ''
    }
  },
  mounted: async function () {
    try {
      let id = this.$route.params.id
      this.loading = true
      this.departamento = {}
      if (id === undefined) {
        this.modo = 'I'
        this.loading = false
        return
      }
      this.modo = 'A'
      this.departamento = await departamentosService.getById(id)
      this.loading = false
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  computed: {
    isAlterar: function () {
      return this.modo === 'A'
    }
  },
  methods: {
    async salvar () {
      try {
        if (this.modo === 'A') {
          this.resultado = await departamentosService.savePut(this.departamento)
          this.$router.push(`/departamentos`)
        } else {
          this.resultado = await departamentosService.savePost(this.departamento)
          this.departamento.descricao = ''
        }
        showFlash('Salvo com sucesso')
      } catch (error) {
        showError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.flex{
    height: 60px;
  }
.e-data-table3 {
  background: red;
}
</style>
